import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  CardImg
} from "reactstrap";

import "./style.css";

// checked

class NavBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      dropdownOpen: false,
      dropdownOpen1: false
    };
    this.toggle = this.toggle.bind(this);
    this.itemToggle = this.itemToggle.bind(this);
    this.itemToggle1 = this.itemToggle1.bind(this);
    this.closeNav = this.closeNav.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onMouseEnter1 = this.onMouseEnter1.bind(this);
    this.onMouseLeave1 = this.onMouseLeave1.bind(this);
  }

  toggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  closeNav() {
    this.setState({ isOpen: false });
  }

  itemToggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
    if (this.state.dropdownOpen1 == true) {
      this.setState({
        dropdownOpen1: false
      });
    }
  }

  itemToggle1() {
    this.setState(prevState => ({
      dropdownOpen1: !prevState.dropdownOpen1
    }));
    if (this.state.dropdownOpen == true) {
      this.setState({
        dropdownOpen: false
      });
    }
  }

  onMouseEnter() {
    this.setState({ dropdownOpen: true });
  }

  onMouseLeave() {
    this.setState({ dropdownOpen: false });
  }
  onMouseEnter1() {
    this.setState({ dropdownOpen1: true });
  }

  onMouseLeave1() {
    this.setState({ dropdownOpen1: false });
  }

  render() {
    console.log(this.state.isOpen);
    return (
      <div>
        <Navbar className="color-nav" dark expand="lg">
          <NavbarBrand href="/">
            <CardImg
              className="lighthouse-logo-nav"
              top
              src="img/lighthouse-logo.png"
              alt="Card image cap"
            />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto pl-4 pl-lg-0 py-3 py-lg-0" navbar>
              <NavItem className="mt-auto mb-auto px-0 px-lg-4">
                <Dropdown
                  className="d-inline-block "
                  //onMouseOver={this.onMouseEnter}
                  onMouseLeave={this.onMouseLeave}
                  isOpen={this.state.dropdownOpen}
                  onClick={this.itemToggle}
                  inNavbar
                >
                  <DropdownToggle className="dropdown-nav nav-options no-hov nav-links pb-2 pl-0">
                    Courses<i className="fas fa-caret-down pb-0"></i>
                  </DropdownToggle>

                  <DropdownMenu
                    className="dropdown-box py-3"
                    onClick={this.closeNav}
                  >
                    <Link style={{ textDecoration: "none" }} to="/browse">
                      <DropdownItem className="dropdown-head-links nav-options all-courses-btn ml-lg-4">
                        All Courses
                      </DropdownItem>
                    </Link>

                    <DropdownItem className="dropdown-head-links drop-downHead pt-lg-">
                      Full-Time Courses
                      <hr className="dropDown-underline " />
                    </DropdownItem>

                    <Link
                      style={{ textDecoration: "none" }}
                      to="/web-development-immersive"
                    >
                      <DropdownItem className="dropdown-links">
                        Software Engineering Immersive
                      </DropdownItem>
                    </Link>
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/data-science-immersive"
                    >
                      <DropdownItem className="dropdown-links">
                        Data Science & Analytics
                      </DropdownItem>
                    </Link>
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/experience-design"
                    >
                      <DropdownItem className="dropdown-links">
                        Experience "UX & CX" Design
                      </DropdownItem>
                    </Link>

                    <DropdownItem className="dropdown-head-links mt-2 drop-downHead">
                      Part-Time Courses
                      <hr className="dropDown-underline " />
                    </DropdownItem>

                    <Link
                      style={{ textDecoration: "none" }}
                      to="/web-development-intensive"
                    >
                      <DropdownItem className="dropdown-links">
                        Full Stack Web Development
                      </DropdownItem>
                    </Link>

                    <Link
                      style={{ textDecoration: "none" }}
                      to="/data-science-intensive"
                    >
                      <DropdownItem className="dropdown-links">
                        Data Science & Analytics
                      </DropdownItem>
                    </Link>

                    <Link
                      style={{ textDecoration: "none" }}
                      to="/digital-marketing"
                    >
                      <DropdownItem className="dropdown-links">
                        Digital Marketing
                      </DropdownItem>
                    </Link>

                    <Link style={{ textDecoration: "none" }} to="/browse">
                      <DropdownItem className="dropdown-head-links drop-downHead">
                        Sponsored Programs
                        <hr className="dropDown-underline " />
                      </DropdownItem>
                    </Link>
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/cloud-academy"
                    >
                      <DropdownItem className="dropdown-links">
                        Cloud Academy
                      </DropdownItem>
                    </Link>
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/cybersecurity-academy"
                    >
                      <DropdownItem className="dropdown-links">
                        Cyber Security
                      </DropdownItem>
                    </Link>
                  </DropdownMenu>
                </Dropdown>
              </NavItem>

              <NavItem
                className="py-2 px-lg-4 mt-auto mb-auto"
                onClick={this.closeNav}
              >
                <Link to="/stay-relevant" className="nav-links nav-options">
                  Stay Relevant
                </Link>
              </NavItem>

              <NavItem className="py-2 px-lg-4 mt-auto mb-auto">
                <Dropdown
                  className="d-inline-block "
                  //onMouseOver={this.onMouseEnter1}
                  onMouseLeave={this.onMouseLeave1}
                  isOpen={this.state.dropdownOpen1}
                  onClick={this.itemToggle1}
                  inNavbar
                >
                  <DropdownToggle
                    style={{ textDecoration: "none" }}
                    className="dropdown-nav no-hov nav-options nav-links pl-0"
                  >
                    {/* <Link
                      style={{ textDecoration: "none" }}
                      className="nav-options nav-links"
                      to="/companies"
                    > */}
                    For Companies<i className="fas fa-caret-down pb-0"></i>
                    {/* </Link> */}
                  </DropdownToggle>

                  <DropdownMenu
                    className="dropdown-box py-3"
                    onClick={this.closeNav}
                  >
                    <Link style={{ textDecoration: "none" }} to="/companies">
                      <DropdownItem className="dropdown-links">
                        Team With Us
                      </DropdownItem>
                    </Link>

                    <DropdownItem className="dropdown-head-links drop-downHead">
                      Academies
                      <hr className="dropDown-underline " />
                    </DropdownItem>

                    <Link
                      style={{ textDecoration: "none" }}
                      to="/cloud-academy"
                    >
                      <DropdownItem className="dropdown-links">
                        Cloud Academy
                      </DropdownItem>
                    </Link>
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/cybersecurity-academy"
                    >
                      <DropdownItem className="dropdown-links">
                        Cyber Security
                      </DropdownItem>
                    </Link>
                    <Link style={{ textDecoration: "none" }} to="/browse">
                      <DropdownItem className="dropdown-head-links mt-lg-1 drop-downHead">
                        Other Programs
                        <hr className="dropDown-underline " />
                      </DropdownItem>
                    </Link>
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/web-development-intensive"
                    >
                      <DropdownItem className="dropdown-links">
                        Software Engineering
                      </DropdownItem>
                    </Link>
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/data-science-immersive"
                    >
                      <DropdownItem className="dropdown-links">
                        Data Science & A.I.
                      </DropdownItem>
                    </Link>
                    <Link
                      style={{ textDecoration: "none" }}
                      to="/digital-marketing"
                    >
                      <DropdownItem className="dropdown-links">
                        Digital Marketing
                      </DropdownItem>
                    </Link>

                    <Link
                      style={{ textDecoration: "none" }}
                      to="/experience-design"
                    >
                      <DropdownItem className="dropdown-links">
                        Design+
                      </DropdownItem>
                    </Link>
                  </DropdownMenu>
                </Dropdown>
              </NavItem>
              <NavItem
                className="py-2 px-lg-4 mt-auto mb-auto"
                onClick={this.closeNav}
              >
                <Link to="/about-us" className="nav-links nav-options">
                  About Us
                </Link>
              </NavItem>

              <NavItem
                className="d-none d-xl-block px-lg-4 mt-auto mb-auto"
                onClick={this.closeNav}
              >
                <Link to="/apply-now">
                  <Button className="apply-now-button ">Apply Now</Button>{" "}
                </Link>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

export default NavBar;
